"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createOrderItem;
function createOrderItem() {
    var fixture = init();

    function init() {
        return {};
    }

    return {
        setItemId: function setItemId(itemId) {
            fixture.itemId = itemId;
            return this;
        },
        setPrice: function setPrice(price) {
            fixture.price = price;
            return this;
        },
        setCount: function setCount(count) {
            fixture.count = count;
            return this;
        },
        setComment: function setComment(comment) {
            fixture.comment = comment;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}